import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery, queryOptions } from "@tanstack/react-query";
import { Suspense } from "react";

import { getCustomTour } from "@/lib/admin-tours.functions";
import { TourForm } from "@/components/admin/TourForm";
import { SiteHeader } from "@/components/site/SiteHeader";

const tourQuery = (id: string) =>
  queryOptions({
    queryKey: ["admin", "tour", id],
    queryFn: () => getCustomTour({ data: { id } }),
  });

export const Route = createFileRoute("/_authenticated/admin/tours/$id/edit")({
  head: () => ({
    meta: [
      { title: "Editar tour — Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: EditTourPage,
});

function EditTourPage() {
  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <div className="mx-auto max-w-5xl px-4 py-10 sm:px-6 lg:px-8">
        <Suspense fallback={<div className="text-muted-foreground">Cargando…</div>}>
          <EditBody />
        </Suspense>
      </div>
    </div>
  );
}

function EditBody() {
  const { id } = Route.useParams();
  const { data } = useSuspenseQuery(tourQuery(id));
  return <TourForm initial={data.tour as any} />;
}
